export interface IPassword {
  currentPassword: string
  password: string
  comparePassword: string
}

export class UserPassword {
  currentPassword = ''
  password = ''
  comparePassword = ''

  constructor(init?: IPassword) {
    Object.assign(this, init)
  }
}

export interface IPasswordDTO {
  currentPassword: string
  password: string
}

export interface IPasswordUpdated {
  emailAddress: string
}
